import { atom, selector } from 'recoil'

export const detailLayerState = atom({
	key: "detailLayerState",
	default: {
		show: false,
		reqCd: undefined,
		authTpCd: undefined
	}
})

export const detailSelectLayerState = atom({
	key: "detailSelectLayerState",
	default: {
		show: false,
	}
})
export const detailLayerAuthState = selector({
	key: "detailLayerAuthState",
	get: ({ get }) => {
		const state = get(detailLayerState)
		return state.authTpCd
	},
})

export const detailLayerShowState = selector({
	key: "detailLayerShowState",
	get: ({ get }) => {
		const state = get(detailLayerState)
		return state.show
	},
	set: ({ set, get }, newValue) => {
		const state = get(detailLayerState)
		set(detailLayerState, {
			...state,
			show: newValue
		})
	}
})

export const detailSelectLayerShowState = selector({
	key: "detailSelectLayerShowState",
	get: ({ get }) => {
		const state = get(detailSelectLayerState)
		return state.show
	},
	set: ({ set, get }, newValue) => {
		const state = get(detailSelectLayerState)
		set(detailSelectLayerState, {
			...state,
			show: newValue
		})
	}
})

export const detailLayerCodeState = selector({
	key: "detailLayerCodeState",
	get: ({ get }) => {
		const state = get(detailLayerState)
		return state.reqCd
	}
})

export const listLayerState = atom({
	key: "listLayerState",
	default: {
		show: false,
		code: undefined
	}
})

export const listLayerShowState = selector({
	key: "listLayerShowState",
	get: ({ get }) => {
		const state = get(listLayerState)
		return state.show
	},
	set: ({ set, get }, newValue) => {
		const state = get(listLayerState)
		set(listLayerState, {
			...state,
			show: newValue
		})
	}
})

export const listLayerCodeState = selector({
	key: "listLayerCodeState",
	get: ({ get }) => {
		const state = get(listLayerState)
		return state.code
	}
})

export const manageDataLayerState = atom({
	key: "manageDataLayerState",
	default: {
		show: false,
		type: undefined,
		step: 1,
		insttCd: undefined
	}
})

export const manageDataLayerController = selector({
	key: "manageDataLayerController",
	get: ({ get }) => {
		return get(manageDataLayerState)
	},
	set: ({ set }, newValue) => {
		set(manageDataLayerState, prev => (
			{
				...prev,
				...newValue
			}
		))
	}
})

export const manageDataLayerShowState = selector({
	key: "manageDataLayerShowState",
	get: ({ get }) => {
		const state = get(manageDataLayerState)
		return state.show
	},
	set: ({ get, set }, newValue) => {
		const state = get(manageDataLayerState)
		set(manageDataLayerState, {
			...state,
			show: newValue
		})
	}
})

export const manageDataLayerTypeState = selector({
	key: "manageDataLayerTypeState",
	get: ({ get }) => {
		const state = get(manageDataLayerState)
		return state.type
	},
	set: ({ get, set }, newValue) => {
		const state = get(manageDataLayerState)
		set(manageDataLayerState, {
			...state,
			type: newValue
		})
	}
})

export const managedDataState = atom({
	key: "managedDataState",
	default: undefined
})

export const confirmLayerState = atom({
	key: "confirmLayerState",
	default: {
		show: false,
		type: undefined
	}
})

export const confirmLayerShowState = selector({
	key: "confirmLayerShowState",
	get: ({ get }) => {
		const state = get(confirmLayerState)
		return state.show
	},
	set: ({ get, set }, newValue) => {
		const state = get(confirmLayerState)
		set(confirmLayerState, {
			...state,
			show: newValue
		})
	}
})

export const confirmLayerTypeState = selector({
	key: "confirmLayerTypeState",
	get: ({ get }) => {
		const state = get(confirmLayerState)
		return state.type
	},
	set: ({ get, set }, newValue) => {
		const state = get(confirmLayerState)
		set(confirmLayerState, {
			...state,
			type: newValue
		})
	}
})

export const manageResultState = atom({
	key: "manageResultState",
	default: undefined
})

export const manageCheckedResultState = selector({
	key: "manageCheckedResultState",
	get: ({ get }) => {
		const result = get(manageResultState)
		if (typeof result === "undefined") return undefined
		const newList = []
		result.forEach(item => {
			if (item.checked) newList.push(item)
		})
		return newList
	}
})

export const manageCheckedResultOrgsState = selector({
	key: "manageCheckedResultOrgsState",
	get: ({ get }) => {
		const result = get(manageResultState)
		const newList = []
		result.forEach(org => {
			if (!org.checked) return
			let found = newList.find(item => item === org.insttNm)
			if (!found) newList.push(org.insttNm)
		})
		return newList
	}
})

export const manageCheckedResultIndsState = selector({
	key: "manageCheckedResultIndsState",
	get: ({ get }) => {
		const result = get(manageResultState)
		const newList = []
		result.forEach(org => {
			if (!org.checked) return
			let found = newList.find(item => item === org.indstCd)
			if (!found) newList.push(org.indstCd)
		})
		return newList
	}
})

export const consentListState = atom({
	key: "consentListState",
	default: undefined
})

